module.exports = __webpack_public_path__ + "static/img/btn_geci_nor@2x.770eabd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/almaMater/btn_geci_nor@2x.png
// module id = 8lPH
// module chunks = 1